<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay offer-edit">
      <div class="card-content" [class.content-loading]="!partner?.applications_offer">

        <h1 class="no-margin">Gerenciar propostas</h1>

        <p>Aqui você pode editar a proposta oferecida aos clientes Allya e também optar por
          participar dos clubes de vantagem que administramos. É possível utilizar a mesma
          proposta para todos os clubes ou personalizar para cada um.</p>

        <div class="offer-list-container">

          <offer-card
            *ngIf="partner"
            [offer]="partner?.offer"
            (onSaveOffer)="updateOffers($event)">
          </offer-card>

          <offer-card
            *ngFor="let offer of partner?.applications_offer"
            [offer]="offer"
            (onSaveOffer)="updateOffers($event)">
          </offer-card>

        </div>

        <div class="loading-overlay" *ngIf="loading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
